import React from "react";
import PublicHeader from "@/components/PublicHeader";
import { Link } from "react-router-dom";
import HerissonLogo from "@/components/HerissonLogo";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#0a0a0b] text-neutral-100 flex flex-col">
      <PublicHeader />
      <main className="flex-1">{children}</main>
      <footer className="border-t border-neutral-800 mt-16">
        <div className="max-w-7xl mx-auto px-4 py-10 grid md:grid-cols-3 gap-8">
          <div>
            <HerissonLogo size="sm" />
            <p className="text-neutral-400 text-sm mt-3">Le Paléo des Marmots — Festival famille en Valais.<br/>29-30 août 2026, Charrat.</p>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-widest text-neutral-500 mb-3">Explorer</div>
            <ul className="space-y-1 text-sm text-neutral-300">
              <li><Link to="/programme" className="hover:text-white">Programme</Link></li>
              <li><Link to="/ateliers" className="hover:text-white">Ateliers</Link></li>
              <li><Link to="/restauration" className="hover:text-white">Restauration</Link></li>
              <li><Link to="/tickets" className="hover:text-white">Billetterie</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-widest text-neutral-500 mb-3">Contact</div>
            <p className="text-sm text-neutral-300">festival@herisson-sous-gazon.ch</p>
            <p className="text-sm text-neutral-500 mt-2">© 2026 Hérisson sous gazon</p>
            <p className="text-xs text-neutral-600 mt-3"><Link to="/" className="hover:text-neutral-400">Console admin →</Link></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
